import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=0febc74d&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"
import style1 from "./Info.vue?vue&type=style&index=1&id=0febc74d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0febc74d",
  null
  
)

export default component.exports